import React from 'react'
import {Grid, Col, Row, Button, Alert} from 'react-bootstrap'
import {Link, browserHistory} from 'react-router'
import {connect} from 'react-redux'
import {Actions} from 'jumpstate'
import HorseFinder from '../Ad/HorseFinder'
import OwnerBox from '../HorseInfo/HorseBreederOwner/OwnerBox/OwnerBox'
import showToastr from '../../utils/showToastr'

import './Layout/IAmOwnerScreen.css'

class IAmOwnerScreen extends React.Component {
  constructor (props) {
    super(props)
    this.state = {
      message: {type: '', context: ''},
      canBeOwner: false,
      isOwnerBoxVisible: false,
      horse: null
    }
    this.onResult = this.onResult.bind(this)
    this.ownerHandler = this.ownerHandler.bind(this)
  }

  ownerHandler (show = true) {
    const {auth} = this.props
    if (!auth.isAuthenticated) {
      showToastr('warning', '', 'لازم است به حساب خود وارد شوید')
      Actions.toggleLoginBox(true)
      return undefined
    }
    this.setState({isOwnerBoxVisible: show})
  }

  onResult (result) {
    if (result.isOwner) {
      return this.setState({canBeOwner: false, horse: null, message: {type: 'warning', context: 'شما قبلا مالکیت این اسب را ثبت نموده اید.'}})
    }
    this.setState({canBeOwner: true, horse: result, message: {type: '', context: ''}})
  }

  render () {
    const {message, canBeOwner, isOwnerBoxVisible, horse} = this.state
    return (
      <Grid className="i-am-owner">
        <Row>
          <Col xs={12}>
            {canBeOwner && <OwnerBox isVisible={isOwnerBoxVisible} toggler={this.ownerHandler} horse={horse} afterSave={() => browserHistory.push(`owner/${this.props.user.ownerKey}`)} />}
          </Col>
        </Row>
        <Row>
          <Col className="horse-find-box" lg={6} lgOffset={3} md={6} mdOffset={3} sm={8} smOffset={2} xs={12} xsOffset={0}>
            <p>نام اسبی که مالک آن هستید را در کادر زیر وارد نمایید.</p>
            <HorseFinder resultHandler={this.onResult} placeholder="نام اسب شما" />
            {message.context && <Alert bsStyle={message.type}>
                {message.context}
            </Alert>}
            {horse && <Button bsStyle="primary" className="BtnCenter btn-lg" disabled={!canBeOwner} onClick={() => this.ownerHandler()}>ثبت مالکیت این اسب</Button>}
            {!horse && <p className="horse-not-found">اگر اسب شما در سیستم یافت نشد می توانید آن را ثبت نمایید.</p>}
            {!horse && <Link to="/new-horse" className="btn btn-success">ثبت اطلاعات اسب</Link>}
          </Col>
        </Row>
      </Grid>
    )
  }
}

function mapStateToProps (state) {
  return {
    user: state.user.currentUser,
    auth: state.auth
  }
}

export default connect(mapStateToProps)(IAmOwnerScreen)



// WEBPACK FOOTER //
// ./src/components/Owner/IAmOwnerScreen.js